"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.splDiscriminate = void 0;
const crypto_1 = require("crypto");
const splDiscriminate = (discriminator, length = 8) => {
    const digest = (0, crypto_1.createHash)('sha256').update(discriminator).digest();
    return digest.subarray(0, length);
};
exports.splDiscriminate = splDiscriminate;
//# sourceMappingURL=splDiscriminate.js.map